export class MmfRowState {
    constructor() {
        this.inEditMode = false
        this.isChecked = false
    }
}